import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import _createForOfIteratorHelper from "/Users/mpagalan/Projects/ormoc-ctzn-form-google/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QrcodeVue from "qrcode.vue";
import LoginForm from "../components/login";
import { Firestore } from "../plugins/firebaseInit";
import Guards from "../plugins/guards";
export default {
  name: "HealthInfo",
  components: {
    QrcodeVue: QrcodeVue,
    LoginForm: LoginForm
  },
  data: function data() {
    return {
      dialog: false,
      signInDialog: false,
      travelHistoryFormValid: false,
      showOverlay: true,
      healthColor: {
        healthy: "#1B5E20",
        suspected: "#F57F17",
        unhealthy: "#4A148C",
        ill: "#B71C1C"
      },
      personalInfo: {
        fname: "",
        lname: "",
        mname: "",
        age: null,
        sex: "Male",
        civil_status: "",
        nationality: "",
        contant_number: "",
        email: "",
        address: ""
      },
      id_no: "",
      id_type: "",
      qrValue: "",
      qvalue: {},
      date_modal: false,
      isValidHealthForm: false,
      travelHistories: [],
      medical_history: "",
      symptomsStatus: false,
      closeContactStatus: false,
      symptoms: [],
      rules: {
        name: [function (value) {
          return !!value || "Required.";
        }, function (value) {
          return (value || "").length <= 30 || "Max 30 characters";
        }],
        required: [function (value) {
          return !!value || "Required.";
        }],
        email: [function (value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return !value || pattern.test(value) || "Invalid e-mail.";
        }]
      },
      genders: ["Male", "Female"],
      civilStatuses: ["Single", "Married", "Widow", "Separated"],
      nationalities: ["Filipino", "American", "Japanese", "Taiwanese", "Chinese", "Singaporean", "Thailander", "Itallian"],
      travelHeaders: [{
        text: "Name of Place Visited",
        value: "travel_name"
      }, {
        text: "Travel Date Period",
        value: "travel_date"
      }, {
        text: "Mode of Transportation",
        value: "travel_mode"
      }, {
        text: "Plate No./Flight No.",
        value: "travel_info"
      }, {
        text: "",
        value: "actions"
      }],
      editedIndex: -1,
      editedHistory: {
        travel_name: "",
        travel_date: new Date().toISOString().substr(0, 10),
        travel_mode: "",
        travel_info: ""
      },
      defaultHistory: {
        travel_name: "",
        travel_date: new Date().toISOString().substr(0, 10),
        travel_mode: "",
        travel_info: ""
      },
      transportationModes: [{
        name: "Land Travel",
        icon: "mdi-bus"
      }, {
        name: "Air Travel",
        icon: "mdi-airplane"
      }, {
        name: "Sea Travel",
        icon: "mdi-ferry"
      }],
      symptomsList: ["Sore Throat / Sakit ang Tutunlan", "Fever / Hilanat", "Cough / Ubo", "Shortness of Breath / Lisud of Ginhawa", "In the course of your travel, do you think you were in close contact with a person with COVID-19 virus?"],
      countries: ["China", "Italy", "Spain", "Iran", "Germany", "US", "France", "South Korea", "Switzerland", "United Kingdom", "Netherlands", "Belgium", "Austria", "Norway", "Sweden", "Denmark", "Malaysia", "Portugal", "Japan", "Canada", "Australia", "Israel", "Brazil", "Qatar", "Singapore", "Indonesia", "Turkey", "Chile", "Thailand", "Bharain", "Saudi Arabia", "Hong Kong", "Kuwait", "UAE", "Taiwan", "Vietnam", "Manila", "Quezon City", "Negros"]
    };
  },
  created: function created() {
    var _this = this;

    if (typeof Storage !== "undefined" && window.localStorage.getItem("personalInfo")) {
      this.personalInfo = JSON.parse(window.localStorage.getItem("personalInfo"));
    }

    if (this.currentUser) {
      Firestore.collection("users").doc(this.currentUser.uid).get().then(function (doc) {
        if (doc.exists) {
          _this.personalInfo = {
            fname: doc.get("fname"),
            lname: doc.get("lname"),
            mname: doc.get("mname"),
            age: doc.get("age"),
            sex: doc.get("sex"),
            civil_status: doc.get("civil_status"),
            nationality: doc.get("nationality"),
            contant_number: doc.get("contant_number"),
            email: doc.get("email"),
            address: doc.get("address")
          };
          _this.symptoms = doc.get("symptoms") || [];
          _this.travelHistories = doc.get("travelHistories") || [];
        } else {
          _this.personalInfo.contant_number = _this.currentUser.phoneNumber;
          _this.personalInfo.email = _this.currentUser.email;
        }

        _this.personalInfo.uid = _this.currentUser.uid;
      }).catch(function (error) {
        console.log("firestore get", error);
      });
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$root.user;
    },
    healthStatus: function healthStatus() {
      var status = {};

      if (this.symptoms.length > 3) {
        status.color = this.healthColor.ill;
        status.symptomsStatus = true;
      }

      if (this.symptoms.length > 0 && this.symptoms.length <= 3) {
        status.color = this.healthColor.unhealthy;
        status.symptomsStatus = true;
      }

      var healthy = true,
          history;

      var _iterator = _createForOfIteratorHelper(this.travelHistories),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          history = _step.value;

          if (this.countries.indexOf(history.travel_name) > -1) {
            healthy = false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (healthy == false) {
        status.color = this.healthColor.suspected;
      } else {
        status.color - this.healthColor.healthy;
      }

      return status;
    }
  },
  methods: {
    resetTravelHistoryForm: function resetTravelHistoryForm() {
      var _this2 = this;

      this.dialog = true;
      this.$nextTick(function () {
        //if (typeof this.$refs.resetTravelHistoryForm != "undefined") {
        _this2.$refs.travelHistoryForm.resetValidation(); // }

      });
    },
    editHistory: function editHistory(item) {
      this.editedIndex = this.travelHistories.indexOf(item);
      this.editedHistory = Object.assign({}, item);
      this.dialog = true;
    },
    deleteHistory: function deleteHistory(item) {
      var index = this.travelHistories.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.travelHistories.splice(index, 1);
    },
    close: function close() {
      var _this3 = this;

      this.$refs.travelHistoryForm.resetValidation();
      this.dialog = false;
      setTimeout(function () {
        _this3.editedHistory = Object.assign({}, _this3.defaultHistory);
        _this3.editedIndex = -1;
      }, 300);
    },
    saveHistory: function saveHistory() {
      if (this.editedIndex > -1) {
        Object.assign(this.travelHistories[this.editedIndex], this.editedHistory);
      } else {
        this.travelHistories.push(this.editedHistory);
      }

      this.close();
    },
    saveHealthForm: function saveHealthForm() {
      var _this4 = this;

      this.$refs.healthForm.validate();

      if (this.isValidHealthForm) {
        if (window.localStorage.getItem("InfoStored")) {
          this.afterSignInDialog();
        } else {
          if (this.currentUser) {
            this.afterSignInDialog();
            this.saveInfoToFirestore();
          } else {
            this.$nextTick(function () {
              _this4.signInDialog = true;
            });
          }
        }
      } else {
        this.$vuetify.goTo("#healthForm", {
          duration: 500,
          offset: 50,
          easing: "linear"
        });
      }
    },
    generateQrValue: function generateQrValue() {
      var _this5 = this;

      if (typeof this.personalInfo != "undefined") {
        this.personalInfo.uid = this.currentUser.uid;
        this.personalInfo.symptomsStatus = this.healthStatus.symptomsStatus; //check if in close contact

        this.personalInfo.closeContactStatus = this.symptoms.indexOf(this.symptomsList[4]) > -1;
        this.qvalue = JSON.parse(JSON.stringify(this.personalInfo));
        this.qvalue.travelHistories = this.travelHistories;
        this.qvalue.symptoms = this.symptoms; //this.qrValue = JSON.stringify(qvalue);

        this.personalInfo.symptomsSize = this.symptoms.length;
        delete this.personalInfo.symptoms;
        delete this.personalInfo.travelHistories;
        Guards.hide(JSON.stringify(this.personalInfo)).then(function (x) {
          _this5.qrValue = JSON.stringify({
            v: Guards.ab2encodeStr(x),
            k: Guards.ab2encodeStr(Guards.iv)
          });
        });
      } else {
        this.qrValue = "";
      }
    },
    signInLater: function signInLater() {
      if (this.currentUser) {
        // get current user personal info
        this.saveInfoToFirestore();
      } else {
        // No current user signin
        this.saveInfoToLocal();
      }

      this.signInDialog = false;
      this.afterSignInDialog();
    },
    saveInfoToFirestore: function saveInfoToFirestore() {
      Firestore.collection("users").doc(this.currentUser.uid).set(this.qvalue).catch(function (error) {
        console.log("FireStoreError", error);
      });
      this.currentUser.updateProfile({
        displayName: "".concat(this.personalInfo.lname, ", ").concat(this.personalInfo.fname, " ").concat(this.personalInfo.mname)
      });
    },
    saveInfoToLocal: function saveInfoToLocal() {
      if (typeof Storage !== "undefined") {
        window.localStorage.setItem("personalInfo", JSON.stringify(this.personalInfo));
        window.localStorage.setItem("InfoStored", true);
      }
    },
    afterSignInDialog: function afterSignInDialog() {
      this.generateQrValue();
      this.showOverlay = false;
      this.$vuetify.goTo("#qrcode", {
        duration: 500,
        offset: 50,
        easing: "easeInOutCubic"
      });
    }
  }
};